import { Component } from '@angular/core'
import { RouteLoggerService } from 'common/util/services/routeLogger.service'

@Component({
  selector: 'auth-root',
  templateUrl: './authRoot.component.pug',
  styleUrls: ['./authRoot.component.scss'],
})
export class AuthRootComponent {
  constructor (
    public routeLogger: RouteLoggerService,
  ) { }
}
